import PropTypes from 'prop-types';
import breakPoints from 'helpers/Styles';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import ProductCardRTS from 'components/ProductCardRTS';
import ProductCardGaming from 'components/ProductCardGaming';

const ProductCards = ({
  allPcModels,
  products,
  buttonLabel,
  fixedPrice,
  readyToShip,
}) => {
  return (
    <div>
      <div className='productCard_section'>
        {readyToShip === true
          ? products.map((product) => (
              <ProductCardRTS
                type='desktop'
                key={product.title1}
                item={product}
                buttonLabel={buttonLabel}
                fixedPrice={fixedPrice}
              />
            ))
          : products.map((product) => (
              <ProductCardGaming
                allPcModels={allPcModels}
                key={product.title1}
                item={product}
                buttonLabel={buttonLabel}
                fixedPrice={fixedPrice}
              />
            ))}
      </div>
      <div className='productCard_section_mobile'>
        <Carousel
          showStatus={false}
          showThumbs={false}
          useKeyboardArrows
          infiniteLoop
          // autoPlay
          interval={5000}
          showIndicators={false}
          swipeable={true}
          swipeScrollTolerance={30}
          preventMovementUntilSwipeScrollTolerance
        >
          {readyToShip === true
            ? products.map((product) => (
                <ProductCardRTS
                  type='mobile'
                  key={product.title1}
                  item={product}
                  buttonLabel={buttonLabel}
                  fixedPrice={fixedPrice}
                />
              ))
            : products.map((product) => (
                <ProductCardGaming
                  allPcModels={allPcModels}
                  key={product.title1}
                  item={product}
                  buttonLabel={buttonLabel}
                  fixedPrice={fixedPrice}
                />
              ))}
        </Carousel>
      </div>
      <style jsx>
        {`
          .productCard_section {
            display: flex;
            flex-wrap: wrap;
            gap: 36px;
          }
          .productCard_section_mobile {
            overflow: hidden;
          }
          @media (max-width: ${breakPoints.medium}) {
            .productCard_section {
              display: none;
            }
          }
          @media (min-width: ${breakPoints.medium}) {
            .productCard_section_mobile {
              display: none;
            }
          }
        `}
      </style>
    </div>
  );
};

ProductCards.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  products: PropTypes.array.isRequired,
  buttonLabel: PropTypes.string,
  fixedPrice: PropTypes.bool,
  readyToShip: PropTypes.bool,
};

ProductCards.defaultProps = {
  buttonLabel: 'START CUSTOMISING',
  fixedPrice: false,
  readyToShip: false,
};

export default ProductCards;
